'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Close = require('../../shared/icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _ShareRecommendationContainer = require('../../Sharing/ShareDialog/ShareRecommendationContainer');

var _ShareRecommendationContainer2 = _interopRequireDefault(_ShareRecommendationContainer);

var _TheatrePlayer = require('../TheatrePlayer');

var _TheatrePlayer2 = _interopRequireDefault(_TheatrePlayer);

var _TheatreFooter = require('../TheatreFooter');

var _TheatreFooter2 = _interopRequireDefault(_TheatreFooter);

var _TheatreRecommendations = require('../TheatreRecommendations');

var _TheatreRecommendations2 = _interopRequireDefault(_TheatreRecommendations);

var _communityContentPlayers = require('../../../shared/logging/community-content-players');

var _communityContentPlayers2 = _interopRequireDefault(_communityContentPlayers);

var _communityContentUtil = require('../../../utils/community-content-util');

var _communityContentUtil2 = _interopRequireDefault(_communityContentUtil);

var _logger = require('../../../utils/logger');

var _pagescrollHelper = require('../../../utils/pagescroll-helper');

var _services = require('../../../utils/services');

var _services2 = _interopRequireDefault(_services);

var _logValues = require('../../../shared/logging/log-values');

var _propTypes = require('../../../shared/prop-types');

var _theatreUtil = require('../utils/theatre-util');

var _theatreUtil2 = _interopRequireDefault(_theatreUtil);

require('./_theatre-dialog.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TheatreDialog = function (_PureComponent) {
  _inherits(TheatreDialog, _PureComponent);

  function TheatreDialog(props) {
    _classCallCheck(this, TheatreDialog);

    var _this = _possibleConstructorReturn(this, (TheatreDialog.__proto__ || Object.getPrototypeOf(TheatreDialog)).call(this, props));

    _this.showSharing = function () {
      var _this$props = _this.props,
          pause = _this$props.pause,
          player = _this$props.player,
          playerId = _this$props.playerId,
          shareTheatreRecommendation = _this$props.shareTheatreRecommendation,
          selectedRecommendation = _this$props.selectedRecommendation;

      if (selectedRecommendation) {
        pause(playerId);
        _this.setState({ shouldResume: !player.paused });
        shareTheatreRecommendation(selectedRecommendation);
      }
    };

    _this.fetchMoreRecommendations = function () {
      var _this$props2 = _this.props,
          communityContentId = _this$props2.communityContentId,
          recommendations = _this$props2.recommendations;

      var communityContentIdString = _communityContentUtil2.default.buildCommunityContentIdFromObject(communityContentId);
      var includeOriginContent = true;
      var feedUserId = null;
      var skip = recommendations && recommendations.length || 0;
      var limit = skip ? 4 : 8;
      var recommenderFilter = 'Immersive';

      _this.props.getRecommendedVideos({
        communityContentId: communityContentIdString,
        feedUserId: feedUserId,
        includeOriginContent: includeOriginContent,
        limit: limit,
        skip: skip,
        recommenderFilter: recommenderFilter
      });
    };

    _this.onCloseTheatre = function () {
      _this.props.closeTheatre();
      (0, _pagescrollHelper.enablePageScroll)();
    };

    _this.onClickRecommendation = function (index, _ref) {
      var communityContentId = _ref.communityContentId,
          reason = _ref.reason;
      var playerId = _this.props.playerId;

      // Not a great pattern here, but better than it was before.

      _this.props.setPlayingIndex(playerId, index);
      _this.logRecommendation(reason, communityContentId);
    };

    _this.onCloseSharing = function () {
      var _this$props3 = _this.props,
          play = _this$props3.play,
          playerId = _this$props3.playerId,
          shareTheatreRecommendation = _this$props3.shareTheatreRecommendation;


      if (_this.state.shouldResume) {
        play(playerId);
      }
      shareTheatreRecommendation(null);
    };

    _this.onResize = function () {
      // We only support desktop browsers at the time of writing
      if (document.body.clientWidth < 800) {
        _this.onCloseTheatre();
      }
    };

    window.addEventListener('resize', _this.onResize);
    return _this;
  }

  _createClass(TheatreDialog, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.fetchMoreRecommendations();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var logData = this.props.logData;


      (0, _logger.logEvent)(_extends({}, logData, {
        func: _logValues.ENTER_IMMERSIVE // sumo
      }));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var recommendations = this.props.recommendations;


      if (nextProps.selectedRecommendation && nextProps.selectedRecommendation !== this.props.selectedRecommendation) {
        this.props.fetchCommunityContentMetadataIfNeeded(nextProps.selectedRecommendation.type, nextProps.selectedRecommendation.relatedId);
      }

      if (this.props.selectedIndex !== nextProps.selectedIndex) {
        // Log autoadvances as clicked recommendations to align with mobile
        this.logRecommendation(nextProps.recommendations[nextProps.selectedIndex].reason, nextProps.selectedRecommendation);
      }

      if (!recommendations && nextProps.recommendations || nextProps.recommendations && recommendations.length !== nextProps.recommendations.length) {
        this.logImpressionsForNewRecommendations(nextProps.recommendations);
      }

      if (recommendations && recommendations.length && recommendations.length !== nextProps.recommendations.length) {
        this.addNewRecommendationsToPlayer(nextProps.recommendations);
      }
    }
  }, {
    key: 'addNewRecommendationsToPlayer',
    value: function addNewRecommendationsToPlayer(recommendations) {
      var _props = this.props,
          insertPlayable = _props.insertPlayable,
          player = _props.player,
          playerId = _props.playerId;

      var index = player.playables.size; // <immutable list>.size()

      recommendations.slice(index).map(_theatreUtil2.default.recommendationToPlayable).forEach(function (playable, i) {
        insertPlayable(playerId, index + i, playable, false);
      });
    }
  }, {
    key: 'logImpressionsForNewRecommendations',
    value: function logImpressionsForNewRecommendations(recommendations) {
      var _props2 = this.props,
          logData = _props2.logData,
          player = _props2.player;

      var indexOfNewRecommendations = player.playables ? player.playables.size : 0; // <immutable list>.size()

      recommendations.forEach(function (recommendation, index) {
        if (index < indexOfNewRecommendations) {
          return;
        }

        var communityContentIdString = _communityContentUtil2.default.buildCommunityContentIdFromObject(recommendation.communityContentId);
        _services2.default.logCommunityContentImpression(communityContentIdString, _extends({}, logData, {
          isAutoPlay: true,
          isRecommendation: !!index,
          suggestionReason: recommendation.reason,
          player: _communityContentPlayers2.default.Immersive
        }));
      });
    }
  }, {
    key: 'logRecommendation',
    value: function logRecommendation(reason, communityContentId) {
      var logData = this.props.logData;

      var communityContentIdString = _communityContentUtil2.default.buildCommunityContentIdFromObject(communityContentId);

      _services2.default.logCommunityVideoRecommendationClick(communityContentIdString, _extends({}, logData, {
        isAutoPlay: true,
        suggestionReason: reason,
        player: _communityContentPlayers2.default.Immersive
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          adTag = _props3.adTag,
          feedContentId = _props3.feedContentId,
          currentUserId = _props3.currentUserId,
          logData = _props3.logData,
          playerId = _props3.playerId,
          recommendations = _props3.recommendations,
          selectedIndex = _props3.selectedIndex,
          sharedRecommendation = _props3.sharedRecommendation;


      var video = recommendations && recommendations[selectedIndex];
      var combinedLogData = _extends({}, logData, {
        player: _communityContentPlayers2.default.Immersive
      });

      return _react2.default.createElement(
        _reactModal2.default,
        {
          className: 'feed-modal theatre-dialog',
          contentLabel: 'theatre-dialog',
          isOpen: true,
          onAfterOpen: _pagescrollHelper.disablePageScroll,
          overlayClassName: 'feed-modal-overlay theatre-dialog-overlay' },
        _react2.default.createElement(
          'div',
          { className: 'theatre-close-button', onClick: this.onCloseTheatre },
          _react2.default.createElement(_Close2.default, null)
        ),
        _react2.default.createElement(
          'div',
          { className: 'theatre-main-content' },
          _react2.default.createElement(_TheatrePlayer2.default, {
            adTag: adTag,
            feedContentId: feedContentId,
            logData: combinedLogData,
            playerId: playerId,
            recommendations: recommendations
          }),
          video && _react2.default.createElement(_TheatreFooter2.default, {
            currentUserId: currentUserId,
            logData: logData,
            showSharing: this.showSharing,
            video: video })
        ),
        _react2.default.createElement(_TheatreRecommendations2.default, {
          onClickRecommendation: this.onClickRecommendation,
          fetchMoreRecommendations: this.fetchMoreRecommendations,
          recommendations: recommendations,
          selectedIndex: selectedIndex }),
        sharedRecommendation && _react2.default.createElement(_ShareRecommendationContainer2.default, {
          onClose: this.onCloseSharing,
          logData: combinedLogData
        })
      );
    }
  }]);

  return TheatreDialog;
}(_react.PureComponent);

TheatreDialog.propTypes = {
  adTag: _propTypes.adTagShape,
  communityContentId: _propTypes.CommunityContentId.isRequired,
  currentUserId: _react.PropTypes.string,
  feedContentId: _react.PropTypes.string.isRequired,
  insertPlayable: _react.PropTypes.func.isRequired,
  logData: _react.PropTypes.object,
  player: _react.PropTypes.object,
  playerId: _react.PropTypes.string.isRequired,
  recommendations: _react.PropTypes.array,
  selectedIndex: _react.PropTypes.number,
  selectedRecommendation: _propTypes.CommunityContentId,
  sharedRecommendation: _propTypes.CommunityContentId,
  // dispatch functions
  closeTheatre: _react.PropTypes.func.isRequired,
  fetchCommunityContentMetadataIfNeeded: _react.PropTypes.func.isRequired,
  getRecommendedVideos: _react.PropTypes.func.isRequired,
  setPlayingIndex: _react.PropTypes.func.isRequired,
  shareTheatreRecommendation: _react.PropTypes.func.isRequired
};
exports.default = TheatreDialog;